import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import { H3 } from '../Typography';
import styles from './styles';

function ProgressDialog(props) {

    let { classes, open, children } = props;

    return (
        <div className={classes.root}>
            <Dialog
                fullScreen
                open={open}
                className={classes.root}>
                <DialogContent className={classes.panel}>
                    <div className={classes.contentRoot}>
                        <div className={classes.message}>
                            <Grid container alignContent="center" justifyContent="center" spacing={2}>
                                <Grid item>
                                    <CircularProgress color="secondary" />
                                </Grid>
                                <Grid item>
                                    <H3 className={classes.messageText}>
                                        {children}
                                    </H3>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}

ProgressDialog.propTypes = {
    open: PropTypes.bool.isRequired
};

const StyledDialog = withStyles(ProgressDialog, styles);

export default StyledDialog;